import { api } from './api';

export interface CompanyUserWithDetails {
  id: number;
  company_id: number;
  user_id: number;
  role: string;
  is_active: boolean;
  company_name?: string;
  user_name?: string;
  user_email?: string;
}

export interface CompanyUserCreate {
  company_id: number;
  user_id: number;
  role: string;
  is_active?: boolean;
}

export interface CompanyUserUpdate {
  role?: string;
  is_active?: boolean;
}

export const companyUsersApi = {
  // Получить компании пользователя
  getCompanyUsersByUser: async (userId: number): Promise<CompanyUserWithDetails[]> => {
    const response = await api.get(`/api/company-users/by-user/${userId}`);
    return response.data;
  },

  // Получить пользователей компании
  getCompanyUsersByCompany: async (companyId: number): Promise<CompanyUserWithDetails[]> => {
    const response = await api.get(`/api/company-users/by-company/${companyId}`);
    return response.data;
  },

  // Получить все связи компаний и пользователей
  getCompanyUsers: async (): Promise<CompanyUserWithDetails[]> => {
    const response = await api.get('/api/company-users');
    return response.data;
  },

  // Создать связь компании и пользователя
  createCompanyUser: async (companyUser: CompanyUserCreate): Promise<CompanyUserWithDetails> => {
    const response = await api.post('/api/company-users', companyUser);
    return response.data;
  },

  // Обновить связь компании и пользователя
  updateCompanyUser: async (id: number, companyUser: CompanyUserUpdate): Promise<CompanyUserWithDetails> => {
    const response = await api.put(`/api/company-users/${id}`, companyUser);
    return response.data;
  },

  // Удалить связь компании и пользователя
  deleteCompanyUser: async (id: number): Promise<void> => {
    await api.delete(`/api/company-users/${id}`);
  }
};

























